import { useCallback, useMemo, useState } from 'react';
import { DataTableSortStatus } from 'mantine-datatable';

interface UseDataTableSortingOptions {
    sorting?: { id: string; desc: boolean }[];
    setSorting?: (sorting: { id: string; desc: boolean }[]) => void;
}

export function useDataTableSorting<T>(options?: UseDataTableSortingOptions) {
    const [localSorting, setLocalSorting] = useState<
        { id: string; desc: boolean }[]
    >([]);

    const sorting = options?.sorting ?? localSorting;
    const setSorting = options?.setSorting ?? setLocalSorting;

    const sortStatus = useMemo((): DataTableSortStatus<T> | undefined => {
        if (!sorting.length) return undefined;
        const sort = sorting[0];
        return {
            columnAccessor: sort.id as keyof T,
            direction: sort.desc ? 'desc' : 'asc',
        };
    }, [sorting]);

    const handleSortStatusChange = useCallback(
        (newSortStatus: DataTableSortStatus<T> | undefined) => {
            if (!newSortStatus) {
                setSorting([]);
                return;
            }
            setSorting([
                {
                    id: newSortStatus.columnAccessor as string,
                    desc: newSortStatus.direction === 'desc',
                },
            ]);
        },
        [setSorting],
    );

    return {
        sorting,
        setSorting,
        sortStatus,
        handleSortStatusChange,
    };
}
